import SelectInputWithLabel from "@vfuk/core-select-input-with-label";
import FloatingLabelSelectStyles from "./FloatingLabelSelectStyles";
import type { SelectInputWithLabelProps } from "@vfuk/core-select-input-with-label/dist/SelectInputWithLabel.types";

export const FloatingLabelSelect = (props: SelectInputWithLabelProps) => (
  <FloatingLabelSelectStyles {...props}>
    <SelectInputWithLabel {...props} />
  </FloatingLabelSelectStyles>
);
